export default __webpack_public_path__ + "assets/d15a3369f4b70613431b1c8db958e5ee.svg";